export const API_PATH_ApiTrafficStudyCommentDelete = '/services/trafic-studies/apiTrafficStudyCommentDelete';
